import { render, staticRenderFns } from "./alerts_dashboard.vue?vue&type=template&id=a11aaf80&scoped=true&"
import script from "./alerts_dashboard.vue?vue&type=script&lang=js&"
export * from "./alerts_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./alerts_dashboard.vue?vue&type=style&index=0&id=a11aaf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11aaf80",
  null
  
)

export default component.exports